export default __webpack_public_path__ + "static/media/itachi-eye.bbc33fdf.png";